export const MeetingMode = Object.freeze({
  CREATE: 'create',
  EDIT: 'edit',
  CLONE: 'clone'
});